/**
 * Client mirror of the API real-time contract
 * (apps/api/src/modules/signalr/realtime.events.ts). Keep in lockstep.
 */

/** The single SignalR client method every server message arrives on. */
export const REALTIME_TARGET = 'message';

export type RealtimeEventType =
  | 'panel.session.opened'
  | 'panel.session.closed'
  | 'panel.attendance.updated'
  | 'panel.member.updated'
  | 'panel.eligible-apps.updated'
  | 'panel.questions.updated'
  | 'candidate-session.started'
  | 'candidate-session.ended'
  | 'candidate-session.summary.updated'
  | 'candidate-session.amendment.updated'
  | 'scoring.updated'
  // HCM review panel (group keyed by the numeric HcmReviewPanel id).
  | 'review-panel.updated'
  | 'review-session.started'
  | 'review-scoring.updated'
  | 'review-session.summary.updated'
  | 'review-session.submitted';

export interface RealtimeMessage {
  type: RealtimeEventType;
  data?: Record<string, unknown>;
  at: number;
}

// Group name helpers — must match the server exactly.
export const panelGroup = (panelId: number | string) => `panel:${panelId}`;
export const userGroup = (userId: string) => `user:${userId}`;
// HCM review panels have no guid; the group is keyed by the numeric panel id.
export const hcmReviewPanelGroup = (panelId: number | string) =>
  `hcm-review-panel:${panelId}`;
